import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Route, Switch, useHistory, useLocation, useParams} from "react-router-dom";
import {routeFunctions, routes} from "../../../../../core/models/static/routes/app-routes";
import OrderViews from "../../common/orders";
import CustomerAvailableCreditsView from "./available-credits";
import useAccessLevels from "../../../../hooks/use-access-levels";
import CustomerAccountReceivableTransactionsView from "./account-receivable-transactions";

const CustomerAccountingViews = () => {
    const history = useHistory();
    const location = useLocation();
    const params = useParams();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Checks the pathname of the url with each change of the url.
     * if the pathname was [accounting.base] then redirects the user to the available credits view.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.customer.accounting.base, exact: true})) {
            if (operatorAccessLevels.packages.sales.customerAvailableCredits) {
                history.replace(routeFunctions.customer.accounting.availableCredits(params.customerId));
            } else if (operatorAccessLevels.packages.sales.invoicesList) {
                history.replace(routeFunctions.customer.accounting.invoices.base(params.customerId));
            } else if (operatorAccessLevels.packages.sales.customerAccountReceivableTransactions) {
                history.replace(routeFunctions.customer.accounting.accountReceivableTransactions(params.customerId));
            } else {
                history.replace(routeFunctions.customer.accounting.base(params.customerId).concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.sales.customerAccountReceivableTransactions, operatorAccessLevels.packages.sales.customerAvailableCredits, operatorAccessLevels.packages.sales.invoicesList, params.customerId])

    return (
        <>
            <Switch>
                <Route path={routes.customer.accounting.base} exact/>
                {
                    operatorAccessLevels.packages.sales.customerAvailableCredits &&
                    <Route path={routes.customer.accounting.availableCredits} exact>
                        <CustomerAvailableCreditsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.invoicesList &&
                    <Route path={[
                        routes.customer.accounting.invoices.single,
                        routes.customer.accounting.invoices.base,
                    ]} exact>
                        <OrderViews allowPayments={true}/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.sales.customerAccountReceivableTransactions &&
                    <Route path={routes.customer.accounting.accountReceivableTransactions} exact>
                        <CustomerAccountReceivableTransactionsView/>
                    </Route>
                }
            </Switch>
        </>

    );
};

export default CustomerAccountingViews;
